import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Subscription } from 'rxjs';
import { MetaTagService } from 'src/app/shared/services/MetaTagService/meta-tag.service';
@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.css'],
})
export class ServicesComponent implements OnInit, OnDestroy {
  serviceCategories: any[] = [];
  language!: string;
  routeSub!: Subscription;

  constructor(
    private route: ActivatedRoute,
    private metaTagService: MetaTagService
  ) {}

  ngOnInit(): void {
    this.language = this.route.snapshot.url[0].path;

    this.routeSub = this.route.params.subscribe((params) => {
      if (params['lang']) {
        this.language = params['lang'];
        this.getResolverData();
      }
    });
    this.getResolverData();
  }

  getResolverData() {
    const resolverData = this.route.snapshot.data['serviceData'];

    if (resolverData) {
      this.serviceCategories = resolverData.serviceComponents;
      this.metaTagService.updateMetaTags(resolverData.metadata.meta);
    } else {
      console.error('Resolver data is undefined');
    }
  }

  ngOnDestroy(): void {
    if (this.routeSub) {
      this.routeSub.unsubscribe();
    }
  }
}
